import * as antlr4 from 'antlr4ng';

export class CustomErrorListener implements antlr4.ANTLRErrorListener {
  private _errors: {
    offendingSymbol: any;
    line: number;
    charPositionInLine: number;
    message: string;
    error: antlr4.RecognitionException | null
  }[] = [];

  public get errors() {
    return this._errors;
  }

  syntaxError(
    recognizer: antlr4.Recognizer<any>,
    offendingSymbol: any,
    line: number,
    charPositionInLine: number,
    msg: string,
    e: antlr4.RecognitionException | null
  ): void {
    this._errors.push({
      offendingSymbol,
      line,
      charPositionInLine,
      message: msg,
      error: e
    });
  }

  reportAmbiguity(
    recognizer: antlr4.Parser,
    dfa: any,
    startIndex: number,
    stopIndex: number,
    exact: boolean,
    ambigAlts: any,
    configs: any
  ): void {
    console.warn('Ambiguity:', { startIndex, stopIndex, ambigAlts });
  }

  reportAttemptingFullContext(
    recognizer: antlr4.Parser,
    dfa: any,
    startIndex: number,
    stopIndex: number,
    conflictingAlts: any,
    configs: any
  ): void {
    console.info('Attempting full context:', { startIndex, stopIndex });
  }

  reportContextSensitivity(
    recognizer: antlr4.Parser,
    dfa: any,
    startIndex: number,
    stopIndex: number,
    prediction: any,
    configs: any
  ): void {
    console.info('Context sensitivity:', { startIndex, stopIndex });
  }
}